var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_6",
    "data-name": "Component 11 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#7bb6c6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M78.6,66.345V78.173L72.522,74.9c0,.862,0,1.668,0,2.475a2.342,2.342,0,0,1-2.37,2.354q-6.287,0-12.573,0A2.343,2.343,0,0,1,55.2,77.356q-.005-5.1,0-10.207a2.252,2.252,0,0,1,1.289-2.121,5.738,5.738,0,0,1,.808-.282H70.419a.47.47,0,0,0,.1.042,2.284,2.284,0,0,1,1.963,1.97,14.232,14.232,0,0,1,.038,1.752c0,.346,0,.693,0,1.067.1-.048.165-.079.23-.114l5.623-3.022C78.448,66.4,78.527,66.377,78.6,66.345Z",
    transform: "translate(-45.349 -51.454)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.7cf5cecbe7ea19465fb219f28e7ddec3.svg";
export { ForwardRef as ReactComponent };